var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "642.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 642.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2010 12790 c-540 -14 -1107 -46 -1325 -75 -337 -46 -571 -161 -656 -325 l-24 -45 5 -625 c6 -821 6 -2731 0 -7375 l-4 -3810 22 -65 c88 -266 343 -371 1017 -420 77 -6 593 -19 1147 -29 981 -18 1033 -18 2015 0 554 10 1073 23 1153 29 486 36 749 106 890 236 67 63 104 127 126 220 15 63 15 472 9 4967 l-8 4897 22 0 21 0 0 409 c0 367 -2 410 -16 413 -14 3 -16 58 -15 573 l2 570 -31 62 c-70 140 -250 240 -533 298 -165 33 -504 59 -1112 86 -307 13 -2279 20 -2705 9z m4110 -6060 l0 -4610 -2935 0 -2935 0 0 4610 0 4610 2935 0 2935 0 0 -4610z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4c3c2e80efa838a8b6d0f1ea984b2c36.svg";
export { ForwardRef as ReactComponent };